import dayjs from "dayjs";

export const obtenerFechaProximosRendimientos = ({item}) => {

    let fechaCreacion = item.fecha
    let hoy = new Date();

    let fechaProxima = dayjs(hoy).add(1, 'month').set('date', new Date(fechaCreacion).getDate()).set('hour', 12).set('minute', 0).set('second', 0);

    return new Date(fechaProxima.toISOString())


}